import { userService } from '@/services/user.service';
import { ref } from '@vue/runtime-core';

const showFirstLoginModal = ref(false);
const isCheckingTerms = ref(false);

export function useTermsAcceptance() {
  /**
   * Vérifie si l'utilisateur a accepté les conditions d'utilisation
   */
  const checkTermsAcceptance = async (): Promise<boolean> => {
    try {
      isCheckingTerms.value = true;
      const response = await userService.checkTermsAcceptance();
      return response.accepted;
    } catch (error) {
      console.error('Erreur lors de la vérification des termes:', error);
      // En cas d'erreur, on considère que les termes n'ont pas été acceptés
      return false;
    } finally {
      isCheckingTerms.value = false;
    }
  };

  /**
   * Accepte les conditions d'utilisation
   */
  const acceptTerms = async (): Promise<boolean> => {
    try {
      const response = await userService.acceptTerms();
      return response.success;
    } catch (error) {
      console.error('Erreur lors de l\'acceptation des termes:', error);
      return false;
    }
  };

  /**
   * Vérifie si l'utilisateur doit voir le modal de première connexion
   */
  const shouldShowFirstLoginModal = async (user: any): Promise<boolean> => {
    if (!user) return false;
    
    const hasAcceptedTerms = await checkTermsAcceptance();
    return !hasAcceptedTerms;
  };

  /**
   * Initialise la vérification des termes pour un utilisateur
   */
  const initTermsCheck = async (user: any) => {
    if (!user) return;
    
    const shouldShow = await shouldShowFirstLoginModal(user);
    if (shouldShow) {
      // Attendre un peu que la page soit chargée
      setTimeout(() => {
        showFirstLoginModal.value = true;
      }, 1000);
    }
  };

  /**
   * Gère la fermeture du modal
   */
  const handleFirstLoginModalClose = () => {
    showFirstLoginModal.value = false;
  };

  /**
   * Gère la validation du modal (acceptation des termes)
   */
  const handleFirstLoginModalValidate = async () => {
    const success = await acceptTerms();
    if (success) {
      showFirstLoginModal.value = false;
    }
    return success;
  };

  return {
    // État
    showFirstLoginModal,
    isCheckingTerms,
    
    // Méthodes
    checkTermsAcceptance,
    acceptTerms,
    shouldShowFirstLoginModal,
    initTermsCheck,
    handleFirstLoginModalClose,
    handleFirstLoginModalValidate,
  };
}
